/**
 * @author
 * @description 考试库模块
 */
import {
  getExamList,
  getAddExamList,
  getEditExam,
  getDelExam,
  getCourses,
  // getCourseSection,
} from "@/api/examBank";

const state = () => ({
  examSet: {},
  initialPaperId: null,
  makeUpPaperId: null,
});

const getters = {};
// 同步方法写在这里--对应commit
const mutations = {
  setExamSet(state, data) {
    state.examSet = data;
  },
  setExamSetData(state, { key, value }) {
    state.examSet[key] = value;
  },
  setExamSetMakeUpPaperId(state, { key, value }) {
    console.log("key", key);
    console.log("value", value);
    state.examSet[key] = value;
  },
  // setAddNewPaperRoute(state, data) {
  //   state.addNewPaperRoute = data;
  // },
};
// 异步请求写在这里--对应dispatch
const actions = {
  // 获取考试列表
  getExamList({}, data) {
    return new Promise((resolve, reject) => {
      getExamList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 添加考试
  getAddExamList({}, data) {
    return new Promise((resolve, reject) => {
      getAddExamList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 编辑考试
  getEditExam({}, data) {
    return new Promise((resolve, reject) => {
      getEditExam(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  //删除考试
  getDelExam({}, data) {
    return new Promise((resolve, reject) => {
      getDelExam(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取课程
  getCourses({}, data) {
    return new Promise((resolve, reject) => {
      getCourses(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // // 获取考试课程章节
  // getCourseSection({}, data) {
  //   return new Promise((resolve, reject) => {
  //     getCourseSection(data)
  //       .then((response) => {
  //         resolve(response);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // },
};

export default { state, getters, mutations, actions };
